import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform, inject } from '@angular/core';

import { TimezoneService } from '@main-application/management/pages/system-configuration/components/date-time-configuration/timezone.service';

@Pipe({
  name: 'todayDate',
})
export class TodayDatePipe implements PipeTransform {
  private timezoneService: TimezoneService = inject(TimezoneService);

  datePipe = new DatePipe('en-US');

  transform(
    value: string | Date,
    format = 'MM/dd/yy',
    showToday = true,
    hideCurrentYear = false,
    useFormat = false
  ): string {
    if (!value) {
      return '';
    }

    const dateValue = new Date(value);
    const today = this.timezoneService.getCurrentDate();

    if (hideCurrentYear) {
      if (isSameYear(dateValue, today)) return this.datePipe.transform(dateValue, useFormat ? 'MM/dd' : 'MMMM d');
      return this.datePipe.transform(dateValue, useFormat ? format : 'MMM d, y');
    }

    return isToday(dateValue, this.timezoneService.getCurrentDate()) && showToday
      ? `Today`
      : this.datePipe.transform(dateValue, format);
  }
}

function isToday(someDate, today) {
  return (
    someDate.getDate() === today.getDate() &&
    someDate.getMonth() === today.getMonth() &&
    someDate.getFullYear() === today.getFullYear()
  );
}

function isSameYear(someDate: Date, today: Date): boolean {
  return someDate.getFullYear() === today.getFullYear();
}
